import "./header.css";
import logoBosch from "../../assets/svgs/Bosch_symbol_logo_black_red.svg";
import lineBosch from "../../assets/img/line-header.png";

function HeaderDefault() {
  return (
    <div className="headerStyle">
      <img className="lineClass" src={lineBosch} alt="Line colors Bosch" />
      <div className="ContainerInfosLogin">
        <h1 className="text">Technical Report Artificial Intelligence</h1>
        <h1 className="textResposivo">TRAI</h1>
        <img className="logoClass" src={logoBosch} alt="Logo Bosch" />
      </div>
    </div>
  );
}
export default HeaderDefault;
